import {Component, computed, effect, ElementRef, forwardRef, input, signal, viewChild} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Mask} from "@models/sportexam";
import {NgxMaskDirective, provideNgxMask} from "ngx-mask";

@Component({
    selector: 'app-input',
    imports: [
        FormsModule,
        NgxMaskDirective
    ],
    templateUrl: './input.component.html',
    styleUrl: './input.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputComponent),
            multi: true
        },
        provideNgxMask()
    ]
})
export class InputComponent implements ControlValueAccessor {
    value = signal<any>(undefined);
    isDisabled = signal<boolean>(false);

    inputAttrs = input<Partial<HTMLInputElement> | null>(null);
    error = input<string>('');
    trim = input<boolean>(false);
    mask = input<Mask>();

    maskValue = computed(() => {
        const x = this.mask();
        if (x === '' || x === null || x === undefined) return '';
        const masks: Record<string, string> = {
            '0': '0',
            '0,0': '0,0',
            '0,00': '0,00',
            'ММ:СС': 'm0:s0',
            'ММ:СС,Т': 'm0:s0,0',
        };
        return masks[x] || '';
    });

    inputElement = viewChild<ElementRef>('inputElement');

    private onChange = (value: any) => {
    };
    private onTouched = () => {
    };

    constructor() {
        effect(() => {
            const attrs = this.inputAttrs();
            const el = this.inputElement()?.nativeElement;
            if (!attrs || !el) return;
            Object.keys(attrs).forEach(attr => {
                el.setAttribute(attr, attrs[attr] as string);
            });
        });
    }

    writeValue(value: any): void {
        this.value.set(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled.set(isDisabled);
    }

    onInputValue(newValue: any) {
        this.value.set(newValue);
        this.onChange(newValue);
    }

    onBlur() {
        if (typeof this.value() === 'string') {
            const newValue = this.trim() ? this.value().trim() : this.value();
            this.value.set(newValue);
            // this.onChange(newValue);
            const el = this.inputElement()?.nativeElement;
            if (el && el.value !== newValue) {
                el.value = newValue;
            }
        }
        this.onTouched();
    }

    focus() {
        this.inputElement()?.nativeElement?.focus();
    }

    blur() {
        this.inputElement()?.nativeElement?.blur();
    }
}
